import { WithBodyMessage } from '@weblite/ts-action/message'

export type RecorderStatus =
  | 'IDLE'
  | 'PRESSED'
  | 'WAITING'
  | 'RECORD'
  | 'PLAYING'

export type SendFieldAction =
  | { type: 'NEW_MESSAGE' }
  | { type: 'REPLY'; iid: number }
  | { type: 'EDIT'; message: WithBodyMessage }
  | {
      type: 'FORWARD'
      forward: { roomId: string; iids: number[]; publicHall?: boolean }
    }

export const DEFAULT_SEND_FIELD_HEIGHT = 55

export type ImagePreviewTypes = 'comment' | 'tune' | 'crop'
export type VideoPreviewTypes = 'comment' | 'compress' | 'trim'

export const MEDIA_PREVIEW_BUTTON_BAR_HEIGHT = 64
